import { BaseCrudService } from '@t-llevo/common-ui';
import { VehicleResponse } from '../models/responses/VehicleResponse';
import { Inject, Injectable } from '@angular/core';
import { Environment, ResponseData } from '@t-llevo/util';
import { HttpClient } from '@angular/common/http';
import { Vehicle } from '../../common/models/Vehicle';
import { VehicleMapper } from '../mappers/VehicleMapper';
import { VehicleRequest } from '../models/requests/VehicleRequest';
import { apiVehicleRoutes as apiRoutes } from '../routes/api-vehicle-routes';

@Injectable()
export class VehicleService extends BaseCrudService<
  Vehicle,
  ResponseData<VehicleResponse>
> {
  constructor(@Inject(Environment) env: Environment, http: HttpClient) {
    super(env, http);
  }

  override transform(data: ResponseData<VehicleResponse>) {
    return {
      ...data,
      results: data.results.map((vehicle) => VehicleMapper(vehicle)),
    };
  }

  createVehicle(params: VehicleRequest) {
    return this.http.post<VehicleResponse>(
      this.env.apiUrl + apiRoutes.routeVehicle,
      params,
    );
  }

  updateVehicle(params: VehicleRequest, id: string) {
    return this.http.patch<VehicleResponse>(
      this.env.apiUrl + apiRoutes.routeVehicle + `${id}`,
      params,
    );
  }

  deleteVehicle(id: string) {
    return this.http.delete(this.env.apiUrl + apiRoutes.routeVehicle + `${id}`);
  }

  getVehicles() {
    return this.http.get<VehicleResponse[]>(
      this.env.apiUrl + apiRoutes.routeVehicle,
    );
  }
}
